import styled from '@emotion/styled'
import { Steps, Paragraph, Table } from 'components/patterns'
import { Col, Row, withFlex } from 'components/patterns/Layout'
import { themeColor } from 'utils/styles'
import ConflictsResolveView from '../ConflictsResolveView'

export const AddCollectionBlurb = styled(Paragraph)`
  width: 232px;
  font-size: 12px;
  margin-left: 8px;
`

export const StepperRow = styled(withFlex(Row))`
  padding: 32px 16px 16px;
  background-color: ${themeColor('whitePrimary')};
  border-bottom: 1px solid ${themeColor('grey')};
`

export const StepperLabelCol = styled(withFlex(Col))`
  justify-content: start;
`

export const StyledSteps = styled(Steps)`
  &&&.ant-steps-label-vertical {
    .ant-steps-item-content {
      width: 125px;
    }
  }

  .ant-steps-item.ant-steps-item-process.ant-steps-item-active
    .ant-steps-item-content {
    font-size: 20px;

    .ant-steps-item-title {
      color: ${themeColor('blueSecondary')};
    }
  }

  .ant-steps-item-icon {
    margin-left: 42px;
  }

  .ant-steps-icon,
  .ant-steps-item-icon,
  .ant-steps-item-title {
    cursor: default !important;
  }
`

export const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${themeColor('whitePrimary')};
  padding: 12px 34px;
  border-top: 1px solid ${themeColor('greySecondary')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`

export const ContentWrapper = styled.div`
  position: fixed;
  top: 166px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: ;
`

export const ContentContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 244px);
  padding-top: 32px;
  background-color: ${themeColor('modalGrey')};
  margin: 0px 0px 80px;
  min-height: 0;
  &.px-18 {
    padding-left: 18px;
    padding-right: 18px;
  }
`

export const InnerContentContainer = styled.div`
  padding: 0 20px;
  height: calc(100vh - 300px);
  overflow-y: auto;
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TableCell = styled.div`
  opacity: ${({ disabled }) => (disabled ? `0.5` : '1')};
`

export const TruncateTableCell = styled(TableCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TruncateTable = styled(Table)`
  &.truncate-table-fixed-layout table {
    table-layout: fixed;
  }
`

export const ReviewHeader = styled.div`
  margin-bottom: 26px;
`

/* Issues 6 & 7 (#496741): Collection part number displayed below the title at
   14px, using Black Secondary color to establish visual hierarchy. */
export const CollectionPartNumber = styled.span`
  display: block;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.29;
  font-weight: normal;
  color: ${themeColor('blackSecondary')};
  margin-top: 2px;
`

export const StyledConflictsResolveView = styled(ConflictsResolveView)`
  height: calc(100vh - 325px);
  && div {
    border-bottom: none;
    h1 {
      font-size: 20px;
      background: ${themeColor('modalGrey')};
      margin: 0 !important;
      padding: 16px;
      border-top: 1px solid ${themeColor('grey')};
    }
  }
`

// (end of file)
